export const CSV_REPORTS_FILENAMES = {
  VSG_FIRMWARE_VERSION: 'wcp_vsg_firmware_versions',
  CORE_REPORTED_FIRMWARE_VERSION: 'wcp_vsg_core_reported_firmware_versions',
  VSG_VEHICLE_DETAILS: 'wcp_vsg_vehicle_details',
  VSG_ONLINE: 'wcp_vsg_online_report',
  VSG_OFFLINE: 'wcp_vsg_offline_report',
  VSG_LOCK_STATUS: 'wcp_vsg_lock_status_report',
  ACTIVATED_VSG: 'wcp_activated_vsg_status_report',
  ORG_FEATURE_UTILIZATION: 'wcp_org_features_utilizing_report',
  VSG_FEATURE_UTILIZATION: 'wcp_vsg_features_utilizing_report',
  VSG_CORE_STANDALONE_DETAILS: 'wcp_vsg_core_standalone_report',
  VSG_ADDON_REPORT: 'wcp_vehicle_addon_report',
  VSG_CORE_STANDALONE_ORG_DETAILS: 'wcp_vsg_core_standalone_org_report',
};

export const CSV_REPORTS_HEADERS = {
  VSG_FIRMWARE_VERSION_HEADERS: ['VSG DUID', 'Vehicle Name', 'Firmware Version', 'Firmware State', 'Organization'],
  CORE_REPORTED_FIRMWARE_VERSION: [
    'VSG DUID',
    'Vehicle Name',
    'Control System',
    'Firmware Version',
    'Firmware State',
    'Organization',
  ],
  VSG_VEHICLE_DETAILS_HEADERS: ['VSG DUID', 'Vehicle Name', 'Type', 'Year', 'Make', 'Model', 'Organization'],
  VSG_ONLINE_STATUS_HEADERS: ['VSG DUID', 'Vehicle Name', 'Status', 'Last Online Time', 'Organization'],
  VSG_OFFLINE_STATUS_REPORT: ['VSG DUID', 'Vehicle Name', 'Status', 'Last Offline Time', 'Organization'],
  VSG_LOCK_STATUS_HEADERS: ['VSG DUID', 'Vehicle Name', 'Security Lock Status', 'Organization'],
  ACTIVATED_VSG_HEADERS: ['VSG DUID', 'Vehicle Name', 'State', 'Last Activation Date', 'Organization'],
  ORG_FEATURE_UTILIZATION: ['Organization ID', 'Organization Name', 'GTT', 'HAAS', 'Telematics', 'Digital Alerting'],
  VSG_FEATURE_UTILIZATION: ['VSG DUID', 'Vehicle Name', 'GTT', 'HAAS', 'Organization'],
  VSG_CORE_STANDALONE_HEADER: ['Core Connected VSG', 'Standalone VSG'],
  VSG_ADDON_FEATURE: ['Addon Type', 'Addon Count'],
  VSG_CORE_STANDALONE_ORG_HEADER: ['Core Connected VSG', 'Standalone VSG', 'Organization'],
};

export const activatedVSG = 'activatedVSG';
export const InitialYear = 2026;
export const defaultSelectionYear = { label: InitialYear, value: InitialYear };
export const additionalSelectionOption = { label: 'All', value: 'All' };
